import { Component, Input, OnInit } from "@angular/core";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-dumb-profile-photo-thumbnail",
  templateUrl: "./profile-photo-thumbnail.component.html",
  styleUrls: ["./profile-photo-thumbnail.component.scss"],
})
export class ProfilePhotoThumbnailComponent implements OnInit {
  @Input() gender: string;
  @Input() profileImage: string;
  @Input() entityName: string;
  profilePhoto: any;
  photo: any;
  picture: any;
  photoflag: boolean = false;
  bannerFlag: boolean = false;
  apiBaseUrl = environment.API_BASE;
  // _entityName: string = "profileImage";

  constructor() {}

  getprofileImage() {
    this.photo = JSON.parse(this.profileImage);
    this.profilePhoto = this.photo[0].filename;
    if(this.profilePhoto != undefined){
    if (this.profilePhoto.indexOf(this.entityName) > -1) {
      this.picture =
        this.apiBaseUrl + "/file-uploader/downloadS3?path=" + this.profilePhoto;
    } else {
      this.picture =
        this.apiBaseUrl +
        "/file-uploader/file2?path=" +
        this.entityName +
        `/${this.profilePhoto}`;
    }
  }
  }

  ngOnInit() {
    if (this.entityName === "Banner") {
      this.bannerFlag = true;
    }
    if (
      this.profileImage != "null" &&
      this.profileImage != "[]" &&
      this.profileImage.length > 0
    ) {
      this.photoflag = true;
      this.getprofileImage();
    }
  }
}
